var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHousingType = function SvgHousingType(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CFCFCF",
    d: "M0 0h43v43H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#housing_type_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-165-1349h1440V778H-165z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21.5,
    r: 21.5,
    fill: "#F2FAF1"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#58B847"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.618 28.937v-9.044a1.464 1.464 0 0 0-2.929 0v5.565a.532.532 0 0 1-.532.532H14.844a.532.532 0 0 1-.532-.532v-5.564a1.464 1.464 0 0 0-2.93 0v9.043h20.236ZM28.343 31.618h1.113v-1.639h-1.433v1.639h.32ZM14.977 31.618v-1.639h-1.432v1.639h1.432Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.545 17.5a2.522 2.522 0 0 1 1.832 2.393v1.42c.304-.174.65-.268 1-.27H26.63c.351.002.696.096 1 .27v-1.42a2.522 2.522 0 0 1 1.833-2.415v-2.191a3.933 3.933 0 0 0-3.941-3.905h-8.04a3.933 3.933 0 0 0-3.936 3.926V17.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.377,
    y: 22.133,
    width: 12.248,
    height: 2.793,
    rx: 1.002
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "housing_type_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(-165 -1349)",
    d: "M0 0h1440v2127H0z"
  })))));
};
export default SvgHousingType;